import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card d-block" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "col-lg-8" }, null, -1)
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "text-lg-right" }
const _hoisted_8 = { class: "card d-block" }
const _hoisted_9 = { class: "tab-wrap" }
const _hoisted_10 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_11 = {
  key: 0,
  class: "nav-item",
  role: "presentation"
}
const _hoisted_12 = {
  key: 1,
  class: "nav-item",
  role: "presentation"
}
const _hoisted_13 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_14 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_15 = {
  key: 0,
  class: "tab-pane fade show active",
  id: "generte-invoice",
  role: "tabpanel",
  "aria-labelledby": "generte-invoice-tab"
}
const _hoisted_16 = { class: "border p-3 rounded mb-3" }
const _hoisted_17 = {
  class: "tab-pane fade",
  id: "requested-invoice",
  role: "tabpanel",
  "aria-labelledby": "requested-invoice-tab"
}
const _hoisted_18 = {
  class: "tab-pane fade",
  id: "received-invoice",
  role: "tabpanel",
  "aria-labelledby": "received-invoice-tab"
}
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "input-btn" }
const _hoisted_22 = { class: "col-md-2" }
const _hoisted_23 = { class: "form-control" }
const _hoisted_24 = { value: "1" }
const _hoisted_25 = { value: "2" }
const _hoisted_26 = { value: "3" }
const _hoisted_27 = {
  key: 0,
  class: "card"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_29 = { class: "table-responsive mb-3 font-12" }
const _hoisted_30 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_31 = { class: "table-primary nowrap-text" }
const _hoisted_32 = { scope: "col" }
const _hoisted_33 = { scope: "col" }
const _hoisted_34 = { scope: "col" }
const _hoisted_35 = { scope: "col" }
const _hoisted_36 = { scope: "col" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 0,
  class: "green-text"
}
const _hoisted_41 = {
  key: 1,
  class: "yellow-text"
}
const _hoisted_42 = {
  key: 2,
  class: "yellow-text"
}
const _hoisted_43 = {
  key: 1,
  class: "card"
}
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_46 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "selectedReceivedInvoice",
  tabindex: -1,
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_47 = { class: "modal-dialog modal-xl modal-dialog-centered" }
const _hoisted_48 = { class: "modal-content" }
const _hoisted_49 = { class: "modal-header" }
const _hoisted_50 = { class: "d-block" }
const _hoisted_51 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_52 = { class: "green-text" }
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_54 = { class: "modal-body" }
const _hoisted_55 = { class: "card" }
const _hoisted_56 = { class: "row align-items-center" }
const _hoisted_57 = { class: "col-md-8" }
const _hoisted_58 = { class: "inline-items" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { class: "green-text" }
const _hoisted_61 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_62 = { class: "text-md-right" }
const _hoisted_63 = {
  key: 0,
  class: "badge badge-dim badge-warning ml-1"
}
const _hoisted_64 = {
  key: 1,
  class: "badge badge-dim badge-warning ml-1 text-orange"
}
const _hoisted_65 = {
  key: 2,
  class: "badge badge-dim badge-warning ml-1 text-green"
}
const _hoisted_66 = {
  key: 3,
  class: "badge badge-dim badge-warning ml-1 text-red"
}
const _hoisted_67 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "col-md-6" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { key: 2 }
const _hoisted_73 = { key: 3 }
const _hoisted_74 = { key: 4 }
const _hoisted_75 = { key: 5 }
const _hoisted_76 = { class: "col-md-6" }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { key: 1 }
const _hoisted_79 = { key: 2 }
const _hoisted_80 = { key: 3 }
const _hoisted_81 = { key: 4 }
const _hoisted_82 = { key: 5 }
const _hoisted_83 = { class: "mt-4" }
const _hoisted_84 = { class: "table-responsive my-3 font-12" }
const _hoisted_85 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_86 = { class: "table-primary nowrap-text" }
const _hoisted_87 = { scope: "col" }
const _hoisted_88 = { scope: "col" }
const _hoisted_89 = { scope: "col" }
const _hoisted_90 = { scope: "col" }
const _hoisted_91 = { class: "row" }
const _hoisted_92 = { class: "col-md-4 offset-md-8" }
const _hoisted_93 = { class: "shadowed-card" }
const _hoisted_94 = { class: "row" }
const _hoisted_95 = { class: "col-6" }
const _hoisted_96 = { class: "col-6 text-right" }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { key: 1 }
const _hoisted_99 = {
  key: 0,
  class: "col-6"
}
const _hoisted_100 = {
  key: 1,
  class: "col-6 text-right"
}
const _hoisted_101 = {
  key: 2,
  class: "col-6"
}
const _hoisted_102 = {
  key: 3,
  class: "col-6 text-right"
}
const _hoisted_103 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_104 = { class: "row" }
const _hoisted_105 = { class: "col-6" }
const _hoisted_106 = { class: "col-6 text-right" }
const _hoisted_107 = { key: 0 }
const _hoisted_108 = { key: 1 }
const _hoisted_109 = { class: "inline-items" }
const _hoisted_110 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectWorkflowAppGoBack = _resolveComponent("ProjectWorkflowAppGoBack")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_ProjectWorkflowGeneratedInvoice = _resolveComponent("ProjectWorkflowGeneratedInvoice")
  const _component_ProjectWorkflowRequestedInvoice = _resolveComponent("ProjectWorkflowRequestedInvoice")
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_big = _resolveComponent("big")
  const _component_AddMemberToTaskEditPhase = _resolveComponent("AddMemberToTaskEditPhase")
  const _component_AddMembeToTask = _resolveComponent("AddMembeToTask")
  const _component_AppDeleteConfirmationModal = _resolveComponent("AppDeleteConfirmationModal")
  const _component_CheckAvaibilityByUser = _resolveComponent("CheckAvaibilityByUser")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.state.ui.isLoading.getPhaseDetails)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_ProjectWorkflowAppGoBack, {
                uuid: _ctx.taskId,
                pathName: `user-todo-details`
              }, null, 8, ["uuid"])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_ErrorList, {
          errors: _ctx.state.ui.error.errorList.phaseDetails,
          hasError: _ctx.state.ui.error.hasError
        }, null, 8, ["errors", "hasError"]),
        _createVNode("div", _hoisted_9, [
          _createVNode("ul", _hoisted_10, [
            (_ctx.tabRoleStatus)
              ? (_openBlock(), _createBlock("li", _hoisted_11, [
                  _createVNode("button", {
                    class: "nav-link active",
                    id: "generte-invoice-tab",
                    "data-toggle": "tab",
                    "data-target": "#generte-invoice",
                    type: "button",
                    role: "tab",
                    "aria-controls": "generte-invoice",
                    "aria-selected": "true",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedTab('generte-invoice')))
                  }, _toDisplayString(_ctx.$t('generate_invoice')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.tabRoleStatus)
              ? (_openBlock(), _createBlock("li", _hoisted_12, [
                  _createVNode("button", {
                    class: "nav-link",
                    id: "requested-invoice-tab",
                    "data-toggle": "tab",
                    "data-target": "#requested-invoice",
                    type: "button",
                    role: "tab",
                    "aria-controls": "requested-invoice",
                    "aria-selected": "false",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedTab('requested-invoice')))
                  }, _toDisplayString(_ctx.$t('requested_invoice')), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("li", _hoisted_13, [
              _createVNode("button", {
                class: "nav-link",
                id: "received-invoice-tab",
                "data-toggle": "tab",
                "data-target": "#received-invoice",
                type: "button",
                role: "tab",
                "aria-controls": "received-invoice",
                "aria-selected": "false",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedTab('received-invoice')))
              }, _toDisplayString(_ctx.$t('received_invoice')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            (_ctx.tabRoleStatus)
              ? (_openBlock(), _createBlock("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    (_ctx.state.data.activeTab === 'generte-invoice')
                      ? (_openBlock(), _createBlock(_component_ProjectWorkflowGeneratedInvoice, {
                          key: 0,
                          id: _ctx.taskId
                        }, null, 8, ["id"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_17, [
              (_ctx.state.data.activeTab === 'requested-invoice')
                ? (_openBlock(), _createBlock(_component_ProjectWorkflowRequestedInvoice, {
                    key: 0,
                    id: _ctx.taskId
                  }, null, 8, ["id"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      placeholder: "Enter Phase title to search...",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.filterReceivedInvoiceList.listByTitle = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.data.filterReceivedInvoiceList.listByTitle]
                    ]),
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: "btn default-btn",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.receivedInvocieByPhaseId && _ctx.receivedInvocieByPhaseId(...args)))
                    }, _toDisplayString(_ctx.$t('search')), 1)
                  ])
                ]),
                _createVNode("p", null, _toDisplayString(_ctx.$t('status')) + ":", 1),
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, [
                    _withDirectives(_createVNode("select", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.filterReceivedInvoiceList.listByStatus = $event)),
                      onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.receivedInvocieByPhaseId && _ctx.receivedInvocieByPhaseId(...args)))
                    }, [
                      _createVNode("option", _hoisted_24, _toDisplayString(_ctx.$t('pending')), 1),
                      _createVNode("option", _hoisted_25, _toDisplayString(_ctx.$t('partial_paid')), 1),
                      _createVNode("option", _hoisted_26, _toDisplayString(_ctx.$t('paid')), 1)
                    ], 544), [
                      [_vModelSelect, _ctx.state.data.filterReceivedInvoiceList.listByStatus]
                    ])
                  ])
                ])
              ]),
              (!_ctx.state.ui.isPostLoading.receivedInvocieByPhaseId)
                ? (_openBlock(), _createBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode("div", _hoisted_29, [
                      _createVNode("table", _hoisted_30, [
                        _createVNode("thead", _hoisted_31, [
                          _createVNode("tr", null, [
                            _createVNode("th", _hoisted_32, _toDisplayString(_ctx.$t('invoice_number')), 1),
                            _createVNode("th", _hoisted_33, _toDisplayString(_ctx.$t('tasks_included')), 1),
                            _createVNode("th", _hoisted_34, _toDisplayString(_ctx.$t('date')), 1),
                            _createVNode("th", _hoisted_35, _toDisplayString(_ctx.$t('status')), 1),
                            _createVNode("th", _hoisted_36, _toDisplayString(_ctx.$t('link')), 1)
                          ])
                        ]),
                        (
                      _ctx.state.data.filterReceivedInvoiceList.list &&
                      _ctx.state.data.filterReceivedInvoiceList.list.length
                    )
                          ? (_openBlock(), _createBlock("tbody", _hoisted_37, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                        .filterReceivedInvoiceList.list, (childPhase, childPhaseIndex) => {
                                return (_openBlock(), _createBlock("tr", { key: childPhaseIndex }, [
                                  _createVNode("td", null, [
                                    _createVNode("p", null, _toDisplayString(childPhase.invoice_no
                              ? childPhase.invoice_no
                              : _ctx.$t('n_a')), 1)
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("p", null, _toDisplayString(childPhase.title ? childPhase.title : _ctx.$t('n_a')), 1)
                                  ]),
                                  _createVNode("td", null, [
                                    (childPhase.modifiedCreateddate)
                                      ? (_openBlock(), _createBlock("p", _hoisted_38, _toDisplayString(childPhase.modifiedCreateddate), 1))
                                      : (_openBlock(), _createBlock("p", _hoisted_39, _toDisplayString(childPhase.invoice_date
                              ? childPhase.invoice_date
                              : _ctx.$t('n_a')), 1))
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("p", null, [
                                      (childPhase.status === 3)
                                        ? (_openBlock(), _createBlock("span", _hoisted_40, _toDisplayString(_ctx.$t('paid')), 1))
                                        : (childPhase.status === 1)
                                          ? (_openBlock(), _createBlock("span", _hoisted_41, _toDisplayString(_ctx.$t('pending')), 1))
                                          : (_openBlock(), _createBlock("span", _hoisted_42, _toDisplayString(_ctx.$t('partial_paid')), 1))
                                    ])
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("a", {
                                      id: "createNewProject",
                                      href: "javascript:void(0)",
                                      class: "btn default-btn mr-2 to-upper",
                                      onClick: ($event: any) => (_ctx.selectedInvoice(childPhase))
                                    }, _toDisplayString(_ctx.$t('view')), 9, ["onClick"]),
                                    _createVNode("a", {
                                      id: "createNewProject",
                                      href: "javascript:void(0)",
                                      class: "btn default-btn",
                                      onClick: ($event: any) => (_ctx.selectedPdf(childPhase.pdf_url))
                                    }, _toDisplayString(_ctx.$t('download')), 9, ["onClick"])
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_43, [
                              _createVNode(_component_EmptyData, {
                                title: _ctx.state.data.title,
                                heading: _ctx.state.data.heading
                              }, null, 8, ["title", "heading"])
                            ]))
                      ])
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_44, [
                    _createVNode("p", null, _toDisplayString(_ctx.$t('loading1')), 1)
                  ]))
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_45, [
        _createVNode("div", _hoisted_46, [
          _createVNode("div", _hoisted_47, [
            _createVNode("div", _hoisted_48, [
              _createVNode("div", _hoisted_49, [
                _createVNode("div", _hoisted_50, [
                  _createVNode("h5", _hoisted_51, [
                    _createVNode("strong", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('invoice_no')) + ": ", 1),
                      _createVNode("span", _hoisted_52, "#" + _toDisplayString(_ctx.state.data.selectedInvoice.invoice_no), 1)
                    ])
                  ])
                ]),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.hideSelectedReceivedInvoice && _ctx.hideSelectedReceivedInvoice(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_53
                ])
              ]),
              _createVNode("div", _hoisted_54, [
                _createVNode("div", _hoisted_55, [
                  _createVNode("div", _hoisted_56, [
                    _createVNode("div", _hoisted_57, [
                      _createVNode("div", _hoisted_58, [
                        _createVNode("ul", null, [
                          _createVNode("li", null, [
                            (
                              _ctx.state.data.selectedInvoice &&
                              _ctx.state.data.selectedInvoice.invoice_date
                            )
                              ? (_openBlock(), _createBlock("p", _hoisted_59, [
                                  _createVNode(_component_big, null, {
                                    default: _withCtx(() => [
                                      _createVNode("strong", null, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('invoice_date')) + ": ", 1),
                                        _createVNode("span", _hoisted_60, _toDisplayString(_ctx.state.data.selectedInvoice.invoice_date), 1)
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    (
                      _ctx.state.data.selectedInvoice &&
                      _ctx.state.data.selectedInvoice.status
                    )
                      ? (_openBlock(), _createBlock("div", _hoisted_61, [
                          _createVNode("div", _hoisted_62, [
                            _createVNode("p", null, [
                              _createVNode("strong", null, _toDisplayString(_ctx.$t('status')) + " :", 1),
                              (_ctx.state.data.selectedInvoice.status === 1)
                                ? (_openBlock(), _createBlock("span", _hoisted_63, _toDisplayString(_ctx.$t('pending')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.state.data.selectedInvoice.status === 2)
                                ? (_openBlock(), _createBlock("span", _hoisted_64, _toDisplayString(_ctx.$t('partial_paid')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.state.data.selectedInvoice.status === 3)
                                ? (_openBlock(), _createBlock("span", _hoisted_65, _toDisplayString(_ctx.$t('paid')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.state.data.selectedInvoice.status === 4)
                                ? (_openBlock(), _createBlock("span", _hoisted_66, _toDisplayString(_ctx.$t('draft')), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_67,
                  _createVNode("div", _hoisted_68, [
                    _createVNode("div", _hoisted_69, [
                      _createVNode("p", null, [
                        _createVNode("strong", null, [
                          _createVNode(_component_big, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('billed_from')) + " :", 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      (
                        _ctx.state.data.selectedInvoice.billed_from_user &&
                        _ctx.state.data.selectedInvoice.billed_from_user.email
                      )
                        ? (_openBlock(), _createBlock("p", _hoisted_70, _toDisplayString(_ctx.state.data.selectedInvoice.billed_from_user.email), 1))
                        : _createCommentVNode("", true),
                      (
                        _ctx.state.data.selectedInvoice.billed_from_user &&
                        _ctx.state.data.selectedInvoice.billed_from_user.full_name
                      )
                        ? (_openBlock(), _createBlock("p", _hoisted_71, _toDisplayString(_ctx.state.data.selectedInvoice.billed_from_user.full_name), 1))
                        : _createCommentVNode("", true),
                      (
                        _ctx.state.data.selectedInvoice.billed_from_user &&
                        _ctx.state.data.selectedInvoice.billed_from_user
                          .address_line1
                      )
                        ? (_openBlock(), _createBlock("p", _hoisted_72, _toDisplayString(_ctx.state.data.selectedInvoice.billed_from_user
                          .address_line1), 1))
                        : _createCommentVNode("", true),
                      (
                        _ctx.state.data.selectedInvoice.billed_from_user &&
                        _ctx.state.data.selectedInvoice.billed_from_user
                          .address_line2
                      )
                        ? (_openBlock(), _createBlock("p", _hoisted_73, _toDisplayString(_ctx.state.data.selectedInvoice.billed_from_user
                          .address_line2), 1))
                        : _createCommentVNode("", true),
                      (
                        _ctx.state.data.selectedInvoice.billed_from_user &&
                        _ctx.state.data.selectedInvoice.billed_from_user.city
                      )
                        ? (_openBlock(), _createBlock("p", _hoisted_74, _toDisplayString(_ctx.state.data.selectedInvoice.billed_from_user.city), 1))
                        : _createCommentVNode("", true),
                      (
                        _ctx.state.data.selectedInvoice.billed_from_user &&
                        _ctx.state.data.selectedInvoice.billed_from_user.country
                      )
                        ? (_openBlock(), _createBlock("p", _hoisted_75, _toDisplayString(_ctx.state.data.selectedInvoice.billed_from_user.country), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_76, [
                      _createVNode("p", null, [
                        _createVNode("strong", null, [
                          _createVNode(_component_big, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('billed_to')) + " :", 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createVNode("div", null, [
                        (
                          _ctx.state.data.selectedInvoice.billed_to_user &&
                          _ctx.state.data.selectedInvoice.billed_to_user.email
                        )
                          ? (_openBlock(), _createBlock("p", _hoisted_77, _toDisplayString(_ctx.state.data.selectedInvoice.billed_to_user.email), 1))
                          : _createCommentVNode("", true),
                        (
                          _ctx.state.data.selectedInvoice.billed_to_user &&
                          _ctx.state.data.selectedInvoice.billed_to_user.full_name
                        )
                          ? (_openBlock(), _createBlock("p", _hoisted_78, _toDisplayString(_ctx.state.data.selectedInvoice.billed_to_user.full_name), 1))
                          : _createCommentVNode("", true),
                        (
                          _ctx.state.data.selectedInvoice.billed_to_user &&
                          _ctx.state.data.selectedInvoice.billed_to_user
                            .address_line1
                        )
                          ? (_openBlock(), _createBlock("p", _hoisted_79, _toDisplayString(_ctx.state.data.selectedInvoice.billed_to_user
                            .address_line1), 1))
                          : _createCommentVNode("", true),
                        (
                          _ctx.state.data.selectedInvoice.billed_to_user &&
                          _ctx.state.data.selectedInvoice.billed_to_user
                            .address_line2
                        )
                          ? (_openBlock(), _createBlock("p", _hoisted_80, _toDisplayString(_ctx.state.data.selectedInvoice.billed_to_user
                            .address_line2), 1))
                          : _createCommentVNode("", true),
                        (
                          _ctx.state.data.selectedInvoice.billed_to_user &&
                          _ctx.state.data.selectedInvoice.billed_to_user.city
                        )
                          ? (_openBlock(), _createBlock("p", _hoisted_81, _toDisplayString(_ctx.state.data.selectedInvoice.billed_to_user.city), 1))
                          : _createCommentVNode("", true),
                        (
                          _ctx.state.data.selectedInvoice.billed_to_user &&
                          _ctx.state.data.selectedInvoice.billed_to_user.country
                        )
                          ? (_openBlock(), _createBlock("p", _hoisted_82, _toDisplayString(_ctx.state.data.selectedInvoice.billed_to_user.country), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createVNode("p", _hoisted_83, [
                    _createVNode("strong", null, [
                      _createVNode(_component_big, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('title')) + " :", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.state.data.selectedInvoice.title), 1)
                  ]),
                  _createVNode("div", _hoisted_84, [
                    _createVNode("table", _hoisted_85, [
                      _createVNode("thead", _hoisted_86, [
                        _createVNode("tr", null, [
                          _createVNode("th", _hoisted_87, _toDisplayString(_ctx.$t('description')), 1),
                          _createVNode("th", _hoisted_88, _toDisplayString(_ctx.$t('cost_per_hour')), 1),
                          _createVNode("th", _hoisted_89, _toDisplayString(_ctx.$t('quantity_per_hour')), 1),
                          _createVNode("th", _hoisted_90, _toDisplayString(_ctx.$t('amount')), 1)
                        ])
                      ]),
                      _createVNode("tbody", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                          .selectedInvoice.invoice_items, (invoiceDetail, invoiceDetailIndex) => {
                          return (_openBlock(), _createBlock("tr", { key: invoiceDetailIndex }, [
                            _createVNode("td", null, _toDisplayString(invoiceDetail.title), 1),
                            _createVNode("td", null, "$ " + _toDisplayString(invoiceDetail.cost), 1),
                            _createVNode("td", null, _toDisplayString(invoiceDetail.quantity), 1),
                            _createVNode("td", null, "$ " + _toDisplayString(invoiceDetail.amount), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_91, [
                    _createVNode("div", _hoisted_92, [
                      _createVNode("div", _hoisted_93, [
                        _createVNode("div", _hoisted_94, [
                          _createVNode("div", _hoisted_95, [
                            _createVNode("p", null, [
                              _createVNode("strong", null, _toDisplayString(_ctx.$t('sub_total')), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_96, [
                            (_ctx.state.data.selectedInvoice.sub_total)
                              ? (_openBlock(), _createBlock("p", _hoisted_97, " $" + _toDisplayString(_ctx.state.data.selectedInvoice.sub_total), 1))
                              : (_openBlock(), _createBlock("p", _hoisted_98, "$0"))
                          ]),
                          (_ctx.state.data.selectedInvoice.tax_amount)
                            ? (_openBlock(), _createBlock("div", _hoisted_99, [
                                _createVNode("p", null, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('tax')) + " (" + _toDisplayString(_ctx.state.data.selectedInvoice.tax) + "%)", 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.state.data.selectedInvoice.tax_amount)
                            ? (_openBlock(), _createBlock("div", _hoisted_100, [
                                _createVNode("p", null, " $" + _toDisplayString(_ctx.state.data.selectedInvoice.tax_amount), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.state.data.selectedInvoice.discount)
                            ? (_openBlock(), _createBlock("div", _hoisted_101, [
                                _createVNode("p", null, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('discount')), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.state.data.selectedInvoice.discount)
                            ? (_openBlock(), _createBlock("div", _hoisted_102, [
                                _createVNode("p", null, " $" + _toDisplayString(_ctx.state.data.selectedInvoice.discount), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_103,
                        _createVNode("div", _hoisted_104, [
                          _createVNode("div", _hoisted_105, [
                            _createVNode("p", null, [
                              _createVNode("strong", null, [
                                _createVNode(_component_big, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('total')), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_106, [
                            (
                              _ctx.state.data.selectedInvoice &&
                              _ctx.state.data.selectedInvoice.total
                            )
                              ? (_openBlock(), _createBlock("p", _hoisted_107, " $" + _toDisplayString(_ctx.state.data.selectedInvoice.total), 1))
                              : (_openBlock(), _createBlock("p", _hoisted_108, "$0"))
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_109, [
                    _createVNode("ul", null, [
                      (
                        _ctx.state.data.selectedInvoice &&
                        _ctx.state.data.selectedInvoice.pdf_url
                      )
                        ? (_openBlock(), _createBlock("li", _hoisted_110, [
                            _createVNode("a", {
                              id: "createNewProject",
                              href: "javascript:void(0)",
                              class: "btn default-btn mr-2",
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.choosePaymentMode && _ctx.choosePaymentMode(...args)))
                            }, _toDisplayString(_ctx.state.ui.isPostLoading.confirmPayment
                            ? _ctx.$t('loading1')
                            : _ctx.$t('pay')), 1),
                            _createVNode("a", {
                              href: "javascript:void(0)",
                              class: "btn default-btn outline",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedPdf(_ctx.state.data.selectedInvoice.pdf_url)))
                            }, _toDisplayString(_ctx.$t('download_pdf')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showTaskUpdateModal)
      ? (_openBlock(), _createBlock(_component_AddMemberToTaskEditPhase, {
          key: 1,
          isActive: _ctx.state.data.showTaskUpdateModal,
          selectedTask: _ctx.state.data.selectedTask,
          minDate: _ctx.state.data.minDate,
          maxDate: _ctx.state.data.maxDate,
          onHideUpdateTaskModal: _ctx.hideUpdateTaskModal,
          onSetUpdatedTask: _ctx.setUpdatedTask
        }, null, 8, ["isActive", "selectedTask", "minDate", "maxDate", "onHideUpdateTaskModal", "onSetUpdatedTask"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showAddMemberModal)
      ? (_openBlock(), _createBlock(_component_AddMembeToTask, {
          key: 2,
          activeTab: _ctx.state.data.activeTab,
          activeUserRole: _ctx.phaseDetails.phase.role_id,
          phaseDetails: _ctx.phaseDetails,
          isActive: _ctx.state.data.showAddMemberModal,
          tasks: _ctx.filteredChildPhases,
          permissions: _ctx.phaseDetails.permissions,
          relatedPermissions: _ctx.phaseDetails.task_permissions,
          amountDepends: _ctx.phaseDetails.amount_depends,
          existingMembers: _ctx.phaseDetails.members,
          roles: _ctx.phaseDetails.roles,
          amountTypes: _ctx.phaseDetails.amount_types,
          onHideAddMemberToTaskModal: _ctx.hideAddMemberToTaskModal,
          onNewAmountTypeFromTaskMember: _ctx.addNewAmountType,
          onAddMemberToTaskData: _ctx.addMemberToTaskData,
          onAddMemberToTaskSuccess: _ctx.addMemberToTaskSuccess,
          onNewRoleFromTaskMember: _ctx.addNewRole
        }, null, 8, ["activeTab", "activeUserRole", "phaseDetails", "isActive", "tasks", "permissions", "relatedPermissions", "amountDepends", "existingMembers", "roles", "amountTypes", "onHideAddMemberToTaskModal", "onNewAmountTypeFromTaskMember", "onAddMemberToTaskData", "onAddMemberToTaskSuccess", "onNewRoleFromTaskMember"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showDeleteConfirmationModal)
      ? (_openBlock(), _createBlock(_component_AppDeleteConfirmationModal, {
          key: 3,
          showConfirmationModal: _ctx.state.data.showDeleteConfirmationModal,
          onButtonTrigger: _ctx.removeSelectedMember,
          onHideConfirmation: _ctx.hideConfirmation,
          message: _ctx.state.data.deleteModalMessage
        }, null, 8, ["showConfirmationModal", "onButtonTrigger", "onHideConfirmation", "message"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showAvailibilityModal)
      ? (_openBlock(), _createBlock(_component_CheckAvaibilityByUser, {
          key: 4,
          startDate: _ctx.phaseDetails.phase.edit_start_date,
          endDate: _ctx.phaseDetails.phase.edit_end_date,
          phaseDetails: _ctx.phaseDetails,
          activeTab: _ctx.state.data.activeTab,
          isActive: _ctx.state.data.showAvailibilityModal,
          selectedEmail: _ctx.state.data.selectedEmail,
          userDetails: _ctx.state.data.selectedUser,
          onCreatedEvent: _ctx.createdEvent,
          onDeletedEvent: _ctx.deletedEvent,
          onHideAvaibilityModal: _ctx.hideAvaibilityModal
        }, null, 8, ["startDate", "endDate", "phaseDetails", "activeTab", "isActive", "selectedEmail", "userDetails", "onCreatedEvent", "onDeletedEvent", "onHideAvaibilityModal"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 5,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ], 64))
}